import {
  Box,
  Button,
  Card,
  CardContent,
  FormControlLabel,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { brighthiveTheme } from "../../../../../theme/theme";

export const FormContainer = styled(Box)`
  padding: 0.5rem 0;
  margin-top: 0.5rem;
  width: 100%;
`;

export const StyledCard = styled(Card)`
  max-width: 600px;
  margin: 0 auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid ${brighthiveTheme.palette.grey[200]};
`;

export const StyledCardContent = styled(CardContent)`
  padding: 1rem;
  padding-bottom: 0rem;
`;

export const FormTitle = styled(Typography)`
  padding: 0.5rem 1rem;
  margin-bottom: 0.2rem;
  color: ${brighthiveTheme.palette.common.black};
  background-color: ${brighthiveTheme.palette.grey[200]};
  font-weight: 600;
  border-bottom: 1px solid ${brighthiveTheme.palette.grey[300]};
`;

export const FieldsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StyledTextField = styled(TextField)<{ hasError?: boolean }>`
  .MuiOutlinedInput-root {
    & fieldset {
      border-color: ${({ hasError }) =>
        hasError
          ? brighthiveTheme.palette.error.main
          : brighthiveTheme.palette.grey[300]};
    }
    &:hover fieldset {
      border-color: ${({ hasError }) =>
        hasError
          ? brighthiveTheme.palette.error.main
          : brighthiveTheme.palette.primary.main};
    }
    &.Mui-focused fieldset {
      border-color: ${({ hasError }) =>
        hasError
          ? brighthiveTheme.palette.error.main
          : brighthiveTheme.palette.primary.main};
    }
  }
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  margin-left: 0;
  margin-right: 0;

  .MuiFormControlLabel-label {
    font-size: 0.875rem;
    color: ${brighthiveTheme.palette.text.primary};
  }

  .MuiCheckbox-root {
    color: ${brighthiveTheme.palette.primary.main};

    &.Mui-checked {
      color: ${brighthiveTheme.palette.primary.main};
    }
  }
`;

export const SourcesContainer = styled(Box)`
  margin-top: 0.3rem;
  padding: 1rem;
  border: 1px solid ${brighthiveTheme.palette.grey[300]};
  border-radius: 4px;
  background-color: ${brighthiveTheme.palette.grey[50]};
  max-height: 200px;
  overflow-y: auto;

  pre {
    margin: 0;
    font-family: "Monaco", "Courier New", monospace;
    font-size: 0.75rem;
    line-height: 1.4;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
`;

export const ButtonsContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
`;

export const CancelButton = styled(Button)`
  border-color: ${brighthiveTheme.palette.grey[400]};
  color: ${brighthiveTheme.palette.grey[600]};

  &:hover {
    border-color: ${brighthiveTheme.palette.grey[500]};
    background-color: ${brighthiveTheme.palette.grey[50]};
  }
`;

export const SubmitButton = styled(Button)`
  background-color: ${brighthiveTheme.palette.primary.main};

  &:hover {
    background-color: ${brighthiveTheme.palette.primary.dark};
  }

  &:disabled {
    background-color: ${brighthiveTheme.palette.grey[300]};
    color: ${brighthiveTheme.palette.grey[500]};
  }
`;
